<flex-column adEl [gap]="0" style="height: 100vh">
  <mat-toolbar adEl="appToolbar" color="primary" style="padding-left: 8px">
    <flex-row adEl="headerBar" [gap]="0" [alignCenter]="true" grow>
      <flex-row
        adEl="brandLockup"
        [gap]="8"
        [alignCenter]="true"
        [fitContent]="true"
      >
        <a
          adEl="brandLink"
          routerLink="/"
          style="
            color: inherit;
            text-decoration: none;
            display: flex;
            align-items: center;
            gap: 8px;
          "
        >
          <img adEl src="assets/logo.png" alt="Logo" style="height: 32px" />
          <span adEl style="padding-top: 6.5px">Process Center</span>
        </a>
      </flex-row>
      <span adEl="headerSpacer" grow style="flex: 1 1 auto"></span>
      @if (currentTenantName) {
      <button
        adEl="tenantChip"
        mat-stroked-button
        [disabled]="!showSwitchTenant"
        (click)="switchTenant()"
        style="
          color: inherit;
          display: inline-flex;
          align-items: center;
          gap: 6px;
        "
      >
        <mat-icon adEl class="material-icons-outlined">domain</mat-icon>
        <span adEl>Tenant: {{currentTenantName}}</span>
      </button>
      }
      <span adEl="headerSpacer2" grow style="flex: 1 1 auto"></span>
      <flex-row
        adEl="headerActions"
        [gap]="8"
        [alignCenter]="true"
        [fitContent]="true"
      >
        @if (authService.currentUser | async) {
        <avatar adEl="userAvatar"></avatar>
        }
      </flex-row>
    </flex-row>
  </mat-toolbar>
  <mat-sidenav-container adEl="sidenavContainer" grow>
    <mat-sidenav-content adEl="sidenavContent">
      <router-outlet adEl="contentOutlet"></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <mat-toolbar
    adEl="appFooter"
    color="primary"
    style="font-size: 12px; min-height: 32px; height: 32px"
    >Version {{packageService.version}}</mat-toolbar
  >
  <tenant-chooser-dialog
    adEl="tenantChooserDialog"
    #tenantChooserDialog
    [options]="{ disableClose: false }"
    (selected)="onTenantSelected()"
  ></tenant-chooser-dialog>
</flex-column>
